import { REQUEST_METHOD } from "../constants";
import ENV_CONFIG from "./environment/index";
import { getLang } from "../utils/common";

export const requestConfig = {
  login: () => ({
    url: "https://hdfc-beta-kong.tothenew.net/authorization/v1/oauth/token",
    options: {
      method: REQUEST_METHOD.POST,
    },
    auth: false,
  }),
  logout: () => ({
    url: "https://hdfc-beta-kong.tothenew.net/investor/v1/logout",
    options: {
      method: REQUEST_METHOD.POST,
    },
    auth: true,
  }),
  commonMethodToCallApis: (languageSet, language, url, auth, method, body) => {
    let lang = getLang();
    return {
      url: languageSet
        ? `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/${url}`
        : `${ENV_CONFIG.API_BASE_URL}/${language}${ENV_CONFIG.VERSION}/${url}`,
      options: {
        method: method === "GET" ? REQUEST_METHOD.GET : REQUEST_METHOD.POST,
        body: body ? body : null,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: auth,
    };
  },
  commonMethodToCallV2Apis: (
    languageSet,
    language,
    url,
    auth,
    method,
    body
  ) => {
    let lang = getLang();
    return {
      url: languageSet
        ? `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSIONV2}/${url}`
        : `${ENV_CONFIG.API_BASE_URL}/${language}${ENV_CONFIG.VERSIONV2}/${url}`,
      options: {
        method: method === "GET" ? REQUEST_METHOD.GET : REQUEST_METHOD.POST,
        body: body ? body : null,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: auth,
    };
  },

  getMenu: () => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSIONV2}/menu`,
      options: {
        method: REQUEST_METHOD.GET,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },
  promotionalHeader: () =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      "promotionsHeader",
      false,
      "GET",
      false
    ),
  getHome: () => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.API_BASE_URL}${ENV_CONFIG.VERSION}/home/homePageData`,
      options: {
        method: REQUEST_METHOD.GET,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },
  getEducationCourses: (lang) => {
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/educourses`,
      options: {
        method: REQUEST_METHOD.GET,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },
  postSebiRegister: (lang, formData) => {
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/sgawareness`,
      options: {
        method: REQUEST_METHOD.POST,
        body: formData,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },
  getProductList: (formData) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/products/listing`,
      options: {
        method: REQUEST_METHOD.POST,
        body: formData,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },
  getProductFilters: () => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/products/filters`,
      options: {
        method: REQUEST_METHOD.GET,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },

  getSchemeDetail: (nodeId) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/products/scheme/${nodeId}`,
      options: {
        method: REQUEST_METHOD.GET,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },
  getSchemeContentNode: (nodeId) =>
    requestConfig.commonMethodToCallApis(
      true,
      "",
      `products/scheme${nodeId}`,
      false,
      "GET",
      false
    ),
  getCreationDetail: (nodeId) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/CreationComponent/data/${nodeId}`,
      options: {
        method: REQUEST_METHOD.POST,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },

  getRebalancingData: (nodeId) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/Rebalancing/data/${nodeId}`,
      options: {
        method: REQUEST_METHOD.POST,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },

  getRebalancingDatawise: (formData) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/Rebalancing/datewise`,
      options: {
        method: REQUEST_METHOD.POST,
        body: formData,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },

  getProductPerformanceTabContent: (lang, nodeId) => {
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/products/performance-tab/${nodeId}`,
      options: {
        method: REQUEST_METHOD.GET,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },

  getProductFundFactTabContent: (lang, nodeId) => {
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/products/facts-tab/${nodeId}`,
      options: {
        method: REQUEST_METHOD.GET,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },

  getProductFundFactNavContent: (lang, nodeId, is_fund_fact) => {
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/products/navs/${nodeId}`,
      options: {
        method: REQUEST_METHOD.POST,
        body: is_fund_fact,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },

  getProductDownloadTabContent: (lang, nodeId) => {
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/products/downloadables-tab/${nodeId}`,
      options: {
        method: REQUEST_METHOD.GET,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },

  getOtherManagedFunds: (lang, managerId) => {
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/products/managers/${managerId}`,
      options: {
        method: REQUEST_METHOD.GET,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },

  getInvestorViewed: (lang) => {
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/investors-viewed`,
      options: {
        method: REQUEST_METHOD.GET,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },

  subscribeProduct: (lang, formData, isProduct) => {
    let url = isProduct ? "subscribe" : "subscription/nav";
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/${url}`,
      options: {
        method: REQUEST_METHOD.POST,
        body: formData,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },

  getFavorites: (formData) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/favourites`,
      options: {
        method: REQUEST_METHOD.POST,
        body: formData,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },
  getCareersContent: () => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/careers`,
      options: {
        method: REQUEST_METHOD.GET,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },

  getCorporateGovernanceDisclosure: (formData) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/about/corporate-governance/disclosures`,
      options: {
        method: REQUEST_METHOD.POST,
        body: formData,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },
  sendOtp: (formData) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSIONV2}/otp/sendOTP`,
      options: {
        method: REQUEST_METHOD.POST,
        body: formData,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },
  verifyDistributor: (formData) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/WhatsappDistributor/verifyDistributor`,
      options: {
        method: REQUEST_METHOD.POST,
        body: formData,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },

  getSubscription: (contentId, tokenId, schemes) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/subscription/validate/nav?contentId=${contentId}&token=${tokenId}&schemes=${schemes}`,
      options: {
        method: REQUEST_METHOD.GET,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },
  removeNavSubscription: (contentId, tokenId) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/subscription/remove/nav?contentId=${contentId}&token=${tokenId}`,
      options: {
        method: REQUEST_METHOD.GET,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },
  productSubscriptionValidate: (contentId, tokenId) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/subscribe/validate?contentId=${contentId}&token=${tokenId}`,
      options: {
        method: REQUEST_METHOD.GET,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },
  getAccountStatement: () => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/requestingastatement`,
      options: {
        method: REQUEST_METHOD.GET,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },
  getMinimumAmounttDetail: (schemeCode) => {
    let url =
      process.env.NODE_ENV != "production" && process.env.NODE_ENV != "beta"
        ? `https://hdfc-uat-kong.tothenew.net/investor/v1/scheme/code/${schemeCode}/min-amount-details`
        : `https://api.hdfcfund.com/investor/v1/scheme/code/${schemeCode}/min-amount-details`;

    return {
      url: url,
      options: {
        method: REQUEST_METHOD.GET,
      },
      auth: false,
    };
  },
  postRemuneration: (formData) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSIONV2}/remuneration`,
      options: {
        method: REQUEST_METHOD.POST,
        body: formData,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },
  getRemunerationYears: () => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSIONV2}/remuneration/fiscal-years`,
      options: {
        method: REQUEST_METHOD.POST,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },
  getGoldCash: (formData, path) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/products/cashComponent/${path}`,
      options: {
        method: REQUEST_METHOD.POST,
        body: formData,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },
  getCashComponent: (formData) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/CreationComponent/dateWise`,
      options: {
        method: REQUEST_METHOD.POST,
        body: formData,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },
  getCookiePolicyContent: () => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/cookiePolicy`,
      options: {
        method: REQUEST_METHOD.GET,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },
  getCities: () => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/promotional/getCities`,
      options: {
        method: REQUEST_METHOD.GET,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },
  registerWhatsApp: (formData, token) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/whatsappService/register`,
      options: {
        method: REQUEST_METHOD.POST,
        body: formData,
        headers: {
          "X-CSRF-Token": token.token,
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },
  registerDistributorWhatsApp: (formData, token) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/WhatsappDistributor/register`,
      options: {
        method: REQUEST_METHOD.POST,
        body: formData,
        headers: {
          "X-CSRF-Token": token.token,
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },
  smallCaseTokenHide: () =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `smallCaseToken`,
      false,
      "POST",
      ""
    ),
  postSmallCase: (ticker, authTokenflagid) => {
    let lang = getLang();
    let data = {
      intent: "TRANSACTION",
      orderConfig: {
        type: "SECURITIES",
        securities: [
          {
            ticker: ticker,
            quantity: "1",
            type: "BUY",
          },
        ],
      },
    };
    return {
      url: "https://gatewayapi.smallcase.com/gateway/hdfcgateway/transaction",
      options: {
        method: REQUEST_METHOD.POST,
        body: JSON.stringify(data),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "x-gateway-authtoken": authTokenflagid.authToken,
          "x-gateway-secret": authTokenflagid.secretKey,
        },
      },
    };
  },
  checkExistingUser: (formData) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/EtfLeadGeneration/checkExistingUser`,
      options: {
        method: REQUEST_METHOD.POST,
        body: formData,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },
  postInvestDataETF: (formData) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/EtfLeadGeneration/register`,
      options: {
        method: REQUEST_METHOD.POST,
        body: formData,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },
  postSmallCaseID: (formData) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/EtfLeadGeneration/updateTransactionDetails`,
      options: {
        method: REQUEST_METHOD.POST,
        body: formData,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },
  verifyOTP: (formData) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/otp/verifyOTP`,
      options: {
        method: REQUEST_METHOD.POST,
        body: formData,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },
  getGoals: () => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.INVESTOR_URL}${ENV_CONFIG.INVESTOR}${ENV_CONFIG.INVESTOR_VERSION}/goal/getAllGoals`,
      options: {
        method: REQUEST_METHOD.GET,
      },
      auth: false,
    };
  },
  getGoalQuestions: (goalId) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.INVESTOR_URL}${ENV_CONFIG.INVESTOR}${ENV_CONFIG.INVESTOR_VERSION}/goal/getGoalDetails/${goalId}`,
      options: {
        method: REQUEST_METHOD.GET,
      },
      auth: false,
    };
  },
  getGoalSuggestions: (params) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.INVESTOR_URL}${ENV_CONFIG.INVESTOR}${ENV_CONFIG.INVESTOR_VERSION}/goal/getSuggestion`,
      options: {
        method: REQUEST_METHOD.POST,
        body: JSON.stringify(params),
        headers: {
          "Content-type": "application/json",
        },
        auth: false,
      },
    };
  },
  verifyKYC: (params) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.INVESTOR_URL}${ENV_CONFIG.INVESTOR}${ENV_CONFIG.INVESTOR_VERSION}/preLogin/verifyKYC`,
      options: {
        method: REQUEST_METHOD.POST,
        body: params,
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
          Archived: "enabled",
          "App-type": "W",
        },
      },
    };
  },
  forceLogout: (params) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.INVESTOR_URL}${ENV_CONFIG.INVESTOR}${ENV_CONFIG.INVESTOR_VERSION}/force/logout`,
      options: {
        method: REQUEST_METHOD.POST,
        body: params,
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
          Archived: "enabled",
          "App-type": "W",
        },
      },
    };
  },
  verifyOTPJava: (params) => {
    let lang = getLang();
    return {
      // url: `${ENV_CONFIG.INVESTOR_URL}/investment/basket/preLogin/verifyKYC`,
      url: `${ENV_CONFIG.INVESTOR_URL}${ENV_CONFIG.INVESTOR}${ENV_CONFIG.INVESTOR_VERSION}/preLogin/verifyOTP`,
      options: {
        method: REQUEST_METHOD.POST,
        body: params,
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
          Archived: "enabled",
          "App-type": "W",
        },
      },
    };
  },
  resendOTPJava: (params) => {
    let lang = getLang();
    return {
      // url: `${ENV_CONFIG.INVESTOR_URL}/investment/basket/preLogin/verifyKYC`,
      url: `${ENV_CONFIG.INVESTOR_URL}${ENV_CONFIG.INVESTOR}${ENV_CONFIG.INVESTOR_VERSION}/registration/resendOTP`,
      options: {
        method: REQUEST_METHOD.POST,
        body: params,
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
          Archived: "enabled",
          "App-type": "W",
        },
      },
    };
  },
  getRiskQuestionAns: () => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.INVESTOR_URL}${ENV_CONFIG.INVESTOR}${ENV_CONFIG.INVESTOR_VERSION}/risk/quesAndAnsDetail`,
      options: {
        method: REQUEST_METHOD.GET,
      },
      auth: false,
    };
  },
  evaluateRiskAppetite: (params) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.INVESTOR_URL}${ENV_CONFIG.INVESTOR}${ENV_CONFIG.INVESTOR_VERSION}/risk/evaluateRiskAppetite`,
      options: {
        method: REQUEST_METHOD.POST,
        body: JSON.stringify(params),
        headers: {
          "Content-type": "application/json",
        },
      },
    };
  },
  getBasketRecommendation: (params) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.INVESTOR_URL}${ENV_CONFIG.INVESTOR}${ENV_CONFIG.INVESTOR_VERSION}/risk/getBasket`,
      options: {
        method: REQUEST_METHOD.POST,
        body: JSON.stringify(params),
        headers: {
          "Content-type": "application/json",
        },
      },
    };
  },
  getRiskAppetitesList: () => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.INVESTOR_URL}${ENV_CONFIG.INVESTOR}${ENV_CONFIG.INVESTOR_VERSION}/risk/getRiskAppetites`,
      options: {
        method: REQUEST_METHOD.GET,
      },
      auth: false,
    };
  },
  getAllBaskets: () => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.INVESTOR_URL}${ENV_CONFIG.INVESTOR}${ENV_CONFIG.INVESTOR_VERSION}/investment/basket/getAllBaskets`,
      options: {
        method: REQUEST_METHOD.GET,
      },
      auth: false,
    };
  },
  savePreLoginData: (params, uuid) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.INVESTOR_URL}${ENV_CONFIG.INVESTOR}${ENV_CONFIG.INVESTOR_VERSION}/preLogin/savePreLoginData/${uuid}`,
      options: {
        method: REQUEST_METHOD.POST,
        body: params,
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
          Archived: "enabled",
          "App-type": "W",
        },
      },
    };
  },
  validateBasketSchemes: (params) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.INVESTOR_URL}${ENV_CONFIG.INVESTOR}${ENV_CONFIG.INVESTOR_VERSION}/investment/basket/validate/schemes`,
      options: {
        method: REQUEST_METHOD.POST,
        body: params,
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
          Archived: "enabled",
          "App-type": "W",
        },
      },
    };
  },
  getHomePageDataStatic: (params) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSIONV2}/homeComponent`,
      options: {
        method: REQUEST_METHOD.POST,
        body: params,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },
  getTrendingFundData: () => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/homeComponent/trendingFunds`,
      options: {
        method: REQUEST_METHOD.GET,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },
  // New Changes of V2
  getStaticPageContent: (pageType) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `template/staticpage/${pageType}`,
      false,
      "GET",
      false
    ),
  getSitemap: () =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `sitemap`,
      false,
      "GET",
      false
    ),
  getInformationDetailContent: (informationId) =>
    requestConfig.commonMethodToCallApis(
      true,
      "",
      `template/information/${informationId}`,
      false,
      "GET",
      false
    ),
  getWhatsAppService: () =>
    requestConfig.commonMethodToCallApis(
      true,
      "",
      `whatsappService`,
      false,
      "GET",
      false
    ),
  getCsrfTokenService: () =>
    requestConfig.commonMethodToCallApis(
      true,
      "",
      `whatsappService/csrfToken`,
      false,
      "GET",
      false
    ),
  getContactUsContent: (type) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `contact-us/${type}`,
      false,
      "GET",
      false
    ),
  getOfficesFilterList: () =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `contact-us/filterslist`,
      false,
      "GET",
      false
    ),
  getChiefInformation: () =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `contactus/chief-information-security-officer`,
      false,
      "GET",
      false
    ),
  getOfficesList: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `contact-us/visit-us/office`,
      false,
      "POST",
      formData
    ),
  getCategory: () =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `reachus/categories`,
      false,
      "GET",
      false
    ),
  getSubjects: (categoryType) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `reachus/subjects/${categoryType}`,
      false,
      "GET",
      false
    ),
  postWriteUsSubmit: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `reachus/contact`,
      false,
      "POST",
      formData
    ),
  // Start Anout Us
  getAboutUsNew: () =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `about/common`,
      false,
      "GET",
      false
    ),
  getAboutUsFinancialInfo: (formData, type) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `about/financial-Information/${type}`,
      false,
      "POST",
      formData
    ),
  getAboutUsCorporateNew: (type, filter) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `about/corporate-profile/${type}`,
      false,
      "GET",
      false
    ),
  getMessageFromLeadersNew: (type) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `about/leadershipTeam/${type}`,
      false,
      "GET",
      false
    ),
  getCorporateGovernanceNew: (type) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `about/corporate-governance/${type}`,
      false,
      "GET",
      false
    ),
  getCorporateGovernancePost: (formData, filter, type) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `about/corporate-governance/${type}${filter ? `/${filter}` : ""}`,
      false,
      "POST",
      formData
    ),
  getAboutUsMediaCenterNew: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `MediaCenter/getmedia`,
      false,
      "POST",
      formData
    ),
  getAboutUsMediaCenterVideo: () =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `MediaCenter/getVideos`,
      false,
      "GET",
      false
    ),
  postCsr: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `about/corporateProfile/csr`,
      false,
      "POST",
      formData
    ),
  // End Anout Us
  // New ETF APi
  getEtf: () =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `etf`,
      false,
      "GET",
      false
    ),
  getEtfFundList: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `etf/etfFunds`,
      false,
      "POST",
      formData
    ),
  getEtfListOfFunds: (formData, type) =>
    requestConfig.commonMethodToCallV2Apis(
      false,
      getLang(),
      `products/navs${type}`,
      false,
      "POST",
      formData
    ),
  postEtfSubscribe: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `etf/subscribe`,
      false,
      "POST",
      formData
    ),
  // End ETF API
  // Learners Corner Start //
  getCalculatorMetaData: (typeData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `learnersCorner/calculatorsData/${typeData}`,
      false,
      "GET",
      false
    ),
  sendOtps: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `otp/sendOTP`,
      false,
      "POST",
      formData
    ),
  sendLearnToolsVerifyOtp: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `otp/verifyOTP`,
      false,
      "POST",
      formData
    ),
  postCallBack: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `learn/callback`,
      false,
      "POST",
      formData
    ),
  calculateTopUpSip: (lang, formData) =>
    requestConfig.commonMethodToCallV2Apis(
      false,
      lang,
      `topupsip`,
      false,
      "POST",
      formData
    ),
  learnCornerLevels: (formData, typeData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `learnersCorner/${typeData}`,
      false,
      "POST",
      formData
    ),
  learnCornerSearch: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `learnersCorner/searchBlog`,
      false,
      "POST",
      formData
    ),
  learnCornerLevelsDetail: (typeData, urlData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `learnersCorner/${typeData}/${urlData}`,
      false,
      "GET",
      false
    ),
  getLearnSubscription: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `learn/subscribe`,
      false,
      "POST",
      formData
    ),
  saveFeedback: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `learnersCorner/feedback`,
      false,
      "POST",
      formData
    ),
  investorawareness: (lang) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      lang,
      `learnersCorner/investorAwareness`,
      false,
      "GET",
      false
    ),
  learnInvestorFaqs: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `learnersCorner/investorFaqs`,
      false,
      "POST",
      formData
    ),
  getStateCityList: (lang) =>
    requestConfig.commonMethodToCallApis(
      false,
      lang,
      `statecitylist`,
      false,
      "GET",
      false
    ),
  postSebiRegisterData: (formData) =>
    requestConfig.commonMethodToCallApis(
      false,
      getLang(),
      `sgawareness`,
      false,
      "POST",
      formData
    ),
  subscribeEmail: (formData) =>
    requestConfig.commonMethodToCallApis(
      true,
      "",
      `MdmessageSubscription/monthly`,
      false,
      "POST",
      formData
    ),
  getIapDocuments: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `learnersCorner/documents`,
      false,
      "POST",
      formData
    ),
  getIapDownloadsSearch: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `learnersCorner/search`,
      false,
      "POST",
      formData
    ),
  getkeyKnowInfo: () =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `template/information/key-know-how`,
      false,
      "GET",
      false
    ),
  cornerSectionOverview: () =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `learnersCorner/cornerSection`,
      false,
      "GET",
      false
    ),
  learnersCornerList: () =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `learnersCorner/common`,
      false,
      "GET",
      false
    ),
  cornerVideoApi: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `learnersCorner/videos`,
      false,
      "POST",
      formData
    ),
  cornerVideodetailApi: (typedata) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `learnersCorner/videos/${typedata}`,
      false,
      "POST",
      typedata
    ),
  cornerPodcastApi: () =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `learnersCorner/podcast`,
      false,
      "GET",
      false
    ),
  getCornerPodcastDetails: (typeData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `learnersCorner/podcast/${typeData}`,
      false,
      "POST",
      typeData
    ),
  toolsCalculate: (lang) =>
    requestConfig.commonMethodToCallV2Apis(
      false,
      getLang(),
      `learnersCorner/calculators`,
      false,
      "GET",
      false
    ),
  getIAPDownloadsMonthsCorner: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      "learnersCorner/iapDocumentsMonths",
      false,
      "POST",
      formData
    ),
  BeginnerDetail: (urlData, formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `learnersCorner/beginner/${urlData}`,
      false,
      "POST",
      formData
    ),
  IntermediateDetail: (urlData, formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `learnersCorner/intermediate/${urlData}`,
      false,
      "POST",
      formData
    ),
  AdvanceDetail: (urlData, formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `learnersCorner/advanced/${urlData}`,
      false,
      "POST",
      formData
    ),
  getBookReview: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      "bookReview/bookListing",
      false,
      "POST",
      formData
    ),
  getBookReviewDetails: (msg) =>
    requestConfig.commonMethodToCallV2Apis(
      false,
      getLang(),
      `bookReview/bookListing/${msg}`,
      false,
      "GET",
      false
    ),
  BookReviewCount: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      "bookReview/bookCount",
      false,
      "POST",
      formData
    ),
  getTheReadingRoom: () =>
    requestConfig.commonMethodToCallV2Apis(
      false,
      getLang(),
      `bookReview`,
      false,
      "GET",
      false
    ),
  PoetryLounge: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `bookReview/poetryLounge`,
      false,
      "POST",
      formData
    ),
  // Learners Corner End //

  // start products and solutions //
  getAllFundProducts: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `products/listing`,
      false,
      "POST",
      formData
    ),
  getAllFundProductsFilters: () =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `products/filters`,
      false,
      "GET",
      false
    ),
  getSingleFundDetails: (formData, typeData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `products/scheme/${typeData}`,
      false,
      "POST",
      formData
    ),
  getSingleFundNav: (formData, type) =>
    requestConfig.commonMethodToCallV2Apis(
      false,
      getLang(),
      `products/navs/${type}`,
      false,
      "POST",
      formData
    ),
  getNfoList: () =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `products/nfo`,
      false,
      "GET",
      false
    ),
  postCompareList: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `compare/listing`,
      false,
      "POST",
      formData
    ),
  postCompareListDublicate: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `compare/listing`,
      false,
      "POST",
      formData
    ),
  postCompareFunds: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `compare/comparefund`,
      false,
      "POST",
      formData
    ),
  postNavOverview: (formData, type) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `products/navs/${type}`,
      false,
      "POST",
      formData
    ),
  getNfoOverview: (formData,type) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `products/nfoScheme/${type}`,
      false,
      "POST",
      formData
    ),
  productIndexList: () =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `indexFunds`,
      false,
      "GET",
      false
    ),
  indexSubscribe: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `indexFunds/subscribe`,
      false,
      "POST",
      formData
    ),
  // end products and solutions //

  //Start Statutory Disclosure new
  getstatutoryList: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      getLang(),
      `disclosures/landing`,
      false,
      "POST",
      formData
    ),
  getnewStatutoryContent: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      getLang(),
      `disclosures`,
      false,
      "POST",
      formData
    ),
  getEmployeeCompensationsaturity: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `disclosures/designatedemployee`,
      false,
      "POST",
      formData
    ),
  getEmployeeCompensationSearchsaturity: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `disclosures/searchdesignatedemployee`,
      false,
      "POST",
      formData
    ),
  getStatutoryFilterNew: (formData, filterType) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `disclosures/${filterType}`,
      false,
      "POST",
      formData
    ),
  getTerNew: () =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `ter/common`,
      false,
      "GET",
      false
    ),
  getTerNoticeContentNew: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `ter/notices`,
      false,
      "POST",
      formData
    ),
  getTerReportContentNew: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `ter/reports`,
      false,
      "POST",
      formData
    ),
  getTerReportMonthFilterNew: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `ter/reports-months`,
      false,
      "POST",
      formData
    ),
  getRemunerationContentNew: () =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `disclosures/remuneration`,
      false,
      "GET",
      false
    ),
  getPublicCautionDataNew: () => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.API_BASE_URL}/${lang}${ENV_CONFIG.VERSION}/disclosures/publicCautions`,
      options: {
        method: REQUEST_METHOD.GET,
        headers: {
          "origin": `${ENV_CONFIG.HEADER_ORIGIN}`,
        },
      },
      auth: false,
    };
  },
  getPassiveFundMonthFilterNew: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `disclosures/passiveFundMonths`,
      false,
      "POST",
      formData
    ),
  //End Statutory Disclosure new
  //start Distributor Corner new
  getDistributorCornerNew: () =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `distributor/common`,
      false,
      "GET",
      false
    ),
  getDistributorCornerFaqs: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `distributor/faqs`,
      false,
      "POST",
      formData
    ),
  //  getDistributorCornerFormsDisclosure: (formData) => requestConfig.commonMethodToCallV2Apis(true, '', `distributor/formsAndDisclosures`, false, 'POST', formData),
  getDistriutorCornerOnboardDigitally: (typeData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `distributor/onboardDigitally/${typeData}`,
      false,
      "GET",
      false
    ),
  getDistriutorCornerOnboardLogin: () =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `distributor/onboard`,
      false,
      "GET",
      false
    ),
  getDistributorCornerMFD: (filterType) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `distributor/beingMfd/${filterType}`,
      false,
      "GET",
      false
    ),
  getDistributerSEBI: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `distributor/sebiCodeOfConduct`,
      false,
      "POST",
      formData
    ),
  getHandBook: () =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `distributor/handbook`,
      false,
      "GET",
      false
    ),
  getHandBookDetails: (msg) =>
    requestConfig.commonMethodToCallV2Apis(
      false,
      getLang(),
      `distributor/handbook/${msg}`,
      false,
      "GET",
      false
    ),
  getDistributorCornerFormsDisclosure: (formData, typeData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `distributor/${typeData}`,
      false,
      "POST",
      formData
    ),
  //end Distributor Corner new

  // Start Investor Services new //
  investorFormList: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      getLang(),
      `investor/forms`,
      false,
      "POST",
      formData
    ),
  noticesAgendaList: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      getLang(),
      `investor/documents`,
      false,
      "POST",
      formData
    ),
  getAgendaMonth: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `investor/investorDocumentsMonths`,
      false,
      "POST",
      formData
    ),
  additionalInfo: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      getLang(),
      `investor/information/additionalInformation`,
      false,
      "POST",
      formData
    ),
  fundLiteratureDocument: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `productliterature/gettype`,
      false,
      "POST",
      formData
    ),
  investorLandingPage: () =>
    requestConfig.commonMethodToCallV2Apis(
      false,
      getLang(),
      `investor/common`,
      false,
      "GET",
      false
    ),
  getInvestorFaq: (formData, type) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `investor/faqs/${type}`,
      false,
      "POST",
      formData
    ),
  getInvestorMarket: (formData, type) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `marketUpdate/${type}`,
      false,
      "POST",
      formData
    ),
  getMarketVideoDetail: (typeData) => requestConfig.commonMethodToCallV2Apis(true, '', `marketUpdate/videos/${typeData}`, false, 'POST', typeData),
  getFundLitrature: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `productliterature/fundLiterature`,
      false,
      "POST",
      formData
    ),
  getFactsheet: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `investor/factsheet`,
      false,
      "POST",
      formData
    ),
  getFactsheetMonth: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `investor/investorDocumentsMonthsFactsheet`,
      false,
      "POST",
      formData
    ),
  getadditionalFundInfo: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `investor/information/schemerelatedinformation`,
      false,
      "POST",
      formData
    ),
  fundDocumentFilters: () =>
    requestConfig.commonMethodToCallV2Apis(
      false,
      getLang(),
      `productliterature/getLists`,
      false,
      "GET",
      false
    ),
  ouronlineservices: (typeData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `template/staticpage/${typeData}`,
      false,
      "GET",
      false
    ),
  getSchemeAccountContentnew: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `scheme-Accounts`,
      false,
      "POST",
      formData
    ),
  getSchemeAccountFiltersnew: () =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `schemeAccounts/getLists`,
      false,
      "GET",
      false
    ),
  getWeeklyPortfolioDetails: () =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `investor/weeklyDetails`,
      false,
      "GET",
      false
    ),
  // End Investor Services
  // start nav and dividend new //
  getNavDividend: (type) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `navAndDividend/${type}`,
      false,
      "POST",
      ""
    ),
  getNavDividendFundFilter: () =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `navAndDividend/fundFilters`,
      false,
      "GET",
      false
    ),
  getHistoricData: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `navAndDividend/historicalData`,
      false,
      "POST",
      formData
    ),
  postNavDividendSearch: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `navAndDividend/searchSchemes`,
      false,
      "POST",
      formData
    ),
  // end nav and dividend new //

  // End Investor Services new //
  verifyPanFolio: (params) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.INVESTOR_URL}${ENV_CONFIG.INVESTOR}${ENV_CONFIG.INVESTOR_VERSION}/statement/verify/pan/folio`,
      options: {
        method: REQUEST_METHOD.POST,
        body: JSON.stringify(params),
        headers: {
          "Content-type": "application/json",
          "X-API-VERSION": "2",
        },
      },
      auth: false,
    };
  },
  verifyAccountStatementOtp: (params) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.INVESTOR_URL}${ENV_CONFIG.INVESTOR}${ENV_CONFIG.INVESTOR_VERSION}/website/verifyOTP`,
      options: {
        method: REQUEST_METHOD.POST,
        body: JSON.stringify(params),
        headers: {
          "Content-type": "application/json",
          "App-type": "W",
          Accept: "application/json",
        },
      },
      auth: false,
    };
  },
  getTokenFromUuid: (uuid) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.INVESTOR_URL}${ENV_CONFIG.INVESTOR}${ENV_CONFIG.INVESTOR_VERSION}/website/getToken/${uuid}`,
      options: {
        method: REQUEST_METHOD.GET,
      },
      auth: false,
    };
  },
  getAccountStatementJava: (params, token) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.INVESTOR_URL}${ENV_CONFIG.INVESTOR}${ENV_CONFIG.INVESTOR_VERSION}/statement/accountStatement`,
      options: {
        method: REQUEST_METHOD.POST,
        body: JSON.stringify(params),
        headers: {
          "Content-type": "application/json",
          "App-type": "W",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "X-API-VERSION": "2",
        },
      },
      auth: false,
    };
  },
  getSipBannerContent: () =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `learn/sipBanner`,
      false,
      "GET",
      false
    ),
  getSipDisclaimerContent: () =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `learn/sipDisclaimer`,
      false,
      "GET",
      false
    ),
  postSipCallUs: (formdata) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `learn/getCallBack`,
      false,
      "POST",
      formdata
    ),
  //meta api
  getWhatsappMeta: () =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `template/metaTags/whats-app-service`,
      false,
      "GET",
      false
    ),
  getMfBytesMetaData: () =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `template/metaTags/mf-bytes-app`,
      false,
      "GET",
      false
    ),
  allSectionsMeta: (type) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `template/metaTags/${type}`,
      false,
      "GET",
      false
    ),
  //Knowledge Stack start 
  mdArticleList: (formData, typeData) => requestConfig.commonMethodToCallV2Apis(true, '', `MdMessage/${typeData}`, false, 'POST', formData),
  getMDMsgData: () => requestConfig.commonMethodToCallV2Apis(true, getLang(), `MdMessage`, false, 'GET', false),
  mdVideosList: (formData, typeData) => requestConfig.commonMethodToCallV2Apis(true, '', `MdMessage/${typeData}`, false, 'POST', formData),
  mdVideosDetails: (typeData) => requestConfig.commonMethodToCallV2Apis(true, '', `MdMessage/videos/${typeData}`, false, 'POST', typeData),
  mdInterviewArticleList: (formData, typeData) => requestConfig.commonMethodToCallV2Apis(true, '', `MdMessage/${typeData}`, false, 'POST', formData),
  mdInterviewVideosList: (formData, typeData) => requestConfig.commonMethodToCallV2Apis(true, '', `MdMessage/${typeData}`, false, 'POST', formData),
  // mdInterviewVideosDetail: (typeData) => requestConfig.commonMethodToCallV2Apis(true, '', `MdMessage/videoInteraction/${typeData}`, false, 'POST', typeData),
  knowledgestackListing: () => requestConfig.commonMethodToCallV2Apis(true, '', `knowledgeStack`, false, 'GET', false),
  getTuesdayTalkingPoints: (formData) => requestConfig.commonMethodToCallV2Apis(true, '', `knowledgeStack/talkingPoints`, false, 'POST', formData),
  mfYearBook: (formData, typeData) => requestConfig.commonMethodToCallV2Apis(true, '', `knowledgeStack/${typeData}`, false, 'POST', formData),
  getChartScope: (formData, typeData) => requestConfig.commonMethodToCallV2Apis(true, '', `knowledgeStack/${typeData}`, false, 'POST', formData),
  getHdfcMfInsights: (formData, typeData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `knowledgeStack/${typeData}`,
      false,
      "POST",
      formData
    ),
  getWeekendBytes: (formData) => requestConfig.commonMethodToCallV2Apis(true, '', `knowledgeStack/weekendBytes`, false, 'POST', formData),
  getMarketReviewList: (formData) => requestConfig.commonMethodToCallV2Apis(true, '', `knowledgeStack/marketReview`, false, 'POST', formData),
  getCreditPolicy: (formData, typeData) => requestConfig.commonMethodToCallV2Apis(true, '', `knowledgeStack/${typeData}`, false, 'POST', formData),
  getMusingsList: (formData) => requestConfig.commonMethodToCallV2Apis(true, '', `knowledgeStack/monthlyMusing`, false, 'POST', formData),
  getKnowledgeStackPodcast: () => requestConfig.commonMethodToCallV2Apis(true, '', `knowledgeStack/podcast`, false, 'GET', false),
  mediaHouseVideosList: (formData, typeData) => requestConfig.commonMethodToCallV2Apis(true, '', `knowledgeStack/${typeData}`, false, 'POST', formData),
  getWebinarList: (formData) => requestConfig.commonMethodToCallV2Apis(true, '', `knowledgeStack/webinar`, false, 'POST', formData),
  knowledgestackRegister: (formData) => requestConfig.commonMethodToCallV2Apis(true, '', `knowledgeStack/webinarRegistration`, false, 'POST', formData),
  getKnowledgestackHandbook: (typeData) => requestConfig.commonMethodToCallV2Apis(true, "", `knowledgeStack/handbook/${typeData}`, false, "GET", false),
  getBehaviouralBlogs: (formData) => requestConfig.commonMethodToCallV2Apis(true, '', `knowledgeStack/behaviouralBlogs`, false, 'POST', formData),
  //detail page
  getKnowledgestackTalkingDetail: (typedata) => requestConfig.commonMethodToCallV2Apis(false, getLang(), `knowledgeStack/talkingPoints/${typedata}`, false, "GET", false),
  getKnowledgestackWeekendBytesDetail: (type) => requestConfig.commonMethodToCallV2Apis(true, "", `knowledgeStack/weekendBytes/${type}`, false, "GET", false),
  getKnowledgestackMonthlyMusingDetail: (typeData) => requestConfig.commonMethodToCallV2Apis(true, "", `knowledgeStack/monthlyMusing/${typeData}`, false, "GET", false),
  getKnowledgestackCreaditPolicyDetail: (typedata) => requestConfig.commonMethodToCallV2Apis(false, getLang(), `knowledgeStack/creditPolicy/${typedata}`, false, "GET", false),
  getMDSpeakArticleDetail: (type, formData) => requestConfig.commonMethodToCallV2Apis(true, "", `MdMessage/mdArticles/${type}`, false, "POST", formData),
  knowledgeStackSubscription: (formData) => requestConfig.commonMethodToCallV2Apis(true, "", `knowledgeStack/subscribe`, false, "POST", formData),
  knowledgeStackSaveFeedback: (formData) => requestConfig.commonMethodToCallV2Apis(true, "", `knowledgeStack/feedback`, false, "POST", formData),
  knowledgeMDsubscribeEmail: (formData) => requestConfig.commonMethodToCallApis(true, "", `MdmessageSubscription/monthly`, false, "POST", formData),
  getKnowledgeStackPodcastDetail: (typeData) => requestConfig.commonMethodToCallV2Apis(true, "", `knowledgeStack/podcast/${typeData}`, false, "GET", false),
  getWebinarDetail: (typeData) => requestConfig.commonMethodToCallV2Apis(true, "", `knowledgeStack/webinar/${typeData}`, false, "GET", false),
  getKnowledgestackBehaviouralBlog: (typedata) => requestConfig.commonMethodToCallV2Apis(false, getLang(), `knowledgeStack/behaviouralBlogs/${typedata}`, false, "GET", false),
  getMarketReviewDetail: (typedata) => requestConfig.commonMethodToCallV2Apis(true, "", `knowledgeStack/marketReview/${typedata}`, false, "GET", false),
  //Knowledge Stack end
  //Goal Marketing Start
  goalMarketingRegister: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `goalPlanning/goalPlanningMarketingData`,
      false,
      "POST",
      formData
    ),
  goalVideoPodcastBlogs: () =>
    requestConfig.commonMethodToCallV2Apis(
      false,
      getLang(),
      `goalPlanning`,
      false,
      "GET",
      false,
    ),
  //Goal Marketing End
  //IAP Page start
  iapPageData: (informationId) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      getLang(),
      `marketingPage/template/${informationId}`,
      false,
      "GET",
      false,
    ),
  iapCallUs: (formdata) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `marketingPage/getCallBack`,
      false,
      "POST",
      formdata
    ),
    iapgetFaqs: (formdata, type) =>
      requestConfig.commonMethodToCallV2Apis(
        true,
        "",
        `marketingPage/getFaqs/${type}`,
        false,
        "POST",
        formdata
    ),  
  //IAP Page End
  // ecart start
  getAllSchemeDetails: () => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.INVESTOR_URL}${ENV_CONFIG.INVESTOR}${ENV_CONFIG.INVESTOR_VERSION}/new/user/fund/detail`,
      options: {
        method: REQUEST_METHOD.GET,
      },
      auth: false
    }
  },
  verifyECartKYC: (params) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.INVESTOR_URL}${ENV_CONFIG.INVESTOR}${ENV_CONFIG.INVESTOR_VERSION}/ecart/kyc/verify`,
      options: {
        method: REQUEST_METHOD.POST,
        body: params,
        headers: {
          'Content-type': 'application/json',
          'Accept': 'application/json',
          'Archived': 'enabled',
          'App-type': 'W',
        },
      },
    }
  },
  sendOtpEcart: (params) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.INVESTOR_URL}${ENV_CONFIG.INVESTOR}${ENV_CONFIG.INVESTOR_VERSION}/ecart/folio/sendotp`,
      options: {
        method: REQUEST_METHOD.POST,
        body: JSON.stringify(params),
        headers: {
          'Content-type': 'application/json'
        },
        auth: false
      },
    }
  },
  saveKycDataEcart: (params) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.INVESTOR_URL}${ENV_CONFIG.INVESTOR}${ENV_CONFIG.INVESTOR_VERSION}/ecart/contact/save`,
      options: {
        method: REQUEST_METHOD.POST,
        body: JSON.stringify(params),
        headers: {
          'Content-type': 'application/json'
        },
        auth: false
      },
    }
  },
  resendOtpEcart: (params) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.INVESTOR_URL}${ENV_CONFIG.INVESTOR}${ENV_CONFIG.INVESTOR_VERSION}/registration/resendOTP`,
      options: {
        method: REQUEST_METHOD.POST,
        body: JSON.stringify(params),
        headers: {
          'Content-type': 'application/json'
        },
        auth: false
      },
    }
  },
  savePreLoginDataEcart: (params, uuid) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.INVESTOR_URL}${ENV_CONFIG.INVESTOR}${ENV_CONFIG.INVESTOR_VERSION}/ecart/save/${uuid}`,
      options: {
        method: REQUEST_METHOD.POST,
        body: params,
        headers: {
          'Content-type': 'application/json',
          // 'Accept': 'application/json',
          // 'Archived': 'enabled',
          // 'App-type': 'W',
        },
      },
    }
  },
  updateFolioEcart: (params, uuid) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.INVESTOR_URL}${ENV_CONFIG.INVESTOR}${ENV_CONFIG.INVESTOR_VERSION}/ecart/update/${uuid}`,
      options: {
        method: REQUEST_METHOD.POST,
        body: params,
        headers: {
          'Content-type': 'application/json',
        },
      },
    }
  },
  getECartTrendingFundData: () => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.INVESTOR_URL}${ENV_CONFIG.INVESTOR}${ENV_CONFIG.INVESTOR_VERSION}/new/user/fund/trending`,
      options: {
        method: REQUEST_METHOD.GET,
      },
      auth: false
    }
  },
  getFundDetails: (params) => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.INVESTOR_URL}${ENV_CONFIG.INVESTOR}${ENV_CONFIG.INVESTOR_VERSION}/validate/fund`,
      options: {
        method: REQUEST_METHOD.POST,
        body: JSON.stringify(params),
        headers: {
          'Content-type': 'application/json'
        },
        auth: false
      }
    }
  },
  getFilterList: () => {
    let lang = getLang();
    return {
      url: `${ENV_CONFIG.INVESTOR_URL}${ENV_CONFIG.INVESTOR}${ENV_CONFIG.INVESTOR_VERSION}/new/user/fund/filter/option`,
      options: {
        method: REQUEST_METHOD.GET,
      },
      auth: false
    }
  },
  // ecart end
  // Glossary Start
  getGlossaryData: (formdata) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `glossary`,
      false,
      "POST",
      formdata
    ),
  getGlossaryAlphabet: () =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `glossary/alphabet`,
      false,
      "GET",
      false
    ),
  // Glossary End
  //Iap women start
  getIAPWomenData: (formdata) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `sipSaheli/getSessionData`,
      false,
      "POST",
      formdata
    ),
  WebinarRegistration: (formdata) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `sipSaheli/webinarRegistration`,
      false,
      "POST",
      formdata
    ),
  getsipSaheliPopup: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `sipSaheli/verifyUser`,
      false,
      "POST",
      formData
    ),
  getIAPWomenMCQ: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `sipSaheli/quiz`,
      false,
      "POST",
      formData
    ),
  SubmitMCQ: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `sipSaheli/getQuestionData`,
      false,
      "POST",
      formData
    ),
  SubmitEventMCQ: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `sipSaheli/eventRegistration`,
      false,
      "POST",
      formData
    ),
  getIAPRegistrationData: (formdata) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `sipSaheli/registrationPageData`,
      false,
      "POST",
      formdata
    ),
  RegisterRegistration: (formdata) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `sipSaheli/registration`,
      false,
      "POST",
      formdata
    ),
  RegisterSubmitMCQ: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `sipSaheli/submitRegistrationData`,
      false,
      "POST",
      formData
    ),
  getRegistrationMedia: () =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `sipSaheli/registrationMediaData`,
      false,
      "GET",
      false
    ),
  //Iap women end
  //Survey start
  SurveyUser: (formData) =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `survey/verifyUser`,
      false,
      "POST",
      formData
    ),
  //Survey end
  //youtuubeshorts start
  getYoutubeShorts: () =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `homeComponent/youTubeShortData`,
      false,
      "GET",
      false
  ),
//youtuubeshorts end
//productoverview graph
postLinegraph: (formData, type) =>
  requestConfig.commonMethodToCallV2Apis(
    true,
    "",
    `products/getHistoricalNavData/${type}`,
    false,
    "POST",
    formData
  ),
  //Jan Nivesh
  getjanNivesh: () =>
    requestConfig.commonMethodToCallV2Apis(
      true,
      "",
      `janNivesh/getCards`,
      false,
      "GET",
      false
  ),
};
